import { HttpClient } from '@/shared/lib/http-client';

export const createPresentationRequest = async({ name, telephone, email }) => {
  const response = await HttpClient.post('/presentation-requests', {
    name,
    telephone,
    email,
  });

  return response.data?.data;
};
